/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Scarica da App Store",
      "Incontra gente di persona",
      "Conosci nuovi amici in zona negli Hive.",
      "Trova chi fa per te",
      "C'è un Hive per qualsiasi interesse!",
      "Un posto sicuro in cui essere sé stessi",
      "Scegli tra Hive privati e pubblici",
      "Inizia",
      "C'è un Hive per qualsiasi interesse",
      "Trova un nuovo gruppo di amici negli Hive di Bumble BFF",
      "Ti invitiamo negli Hive",
      "Conosci gruppi di persone in zona con la nuova funzionalità di Bumble BFF: gli Hive. Crea subito il tuo profilo BFF sull'app di Bumble.",
      "Disponibile su Google Play",
      "Preferenze cookie",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "giorni"
            ],
            "singular": [
                  "giorno"
            ]
      },
      "hour": {
            "plural": [
                  "ore"
            ],
            "singular": [
                  "ora"
            ]
      },
      "minute": {
            "plural": [
                  "minuti"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mesi"
            ],
            "singular": [
                  "mese"
            ]
      },
      "second": {
            "plural": [
                  "secondi"
            ],
            "singular": [
                  "secondo"
            ]
      },
      "year": {
            "plural": [
                  "anni"
            ],
            "singular": [
                  "anno"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
